import { Component, forwardRef, inject, Input } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuthorizationsApiClientService } from '../../../../../../../core/src/lib/api/v1/api/authorizationsApi.client.service';
import { NIASBizBllModelsAuthDocumentInfo } from '../../../../../../../core/src/lib/api/v1/model/nIASBizBllModelsAuthDocumentInfo';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { NIASBizBllModelsEntityInfo } from '../../../../../../../core/src/lib/api/v1/model/nIASBizBllModelsEntityInfo';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperApiClientService } from '../../../../../../../core/src/lib/api/v1';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AlertService } from '../../../../../../../core/src/lib/components/alert/alert.service';
import { AuthorisationsPageSupervisor } from '../../authorisationsPage/authorisations-page-supervisor/authorisations-page-supervisor.component';

@Component({
  selector: 'app-expanded-authorisation',
  imports: [NzButtonModule, NzIconModule, CommonModule, NzGridModule],
  templateUrl: './expanded-authorisation.component.html',
  styleUrl: './expanded-authorisation.component.scss',
})
export class ExpandedAuthorisationComponent {
  @Input() row: any;
  private authorisationsApiClientService = inject(AuthorizationsApiClientService);
  private helperApiService = inject(HelperApiClientService);
  fetchedDocument: NIASBizBllModelsAuthDocumentInfo;
  private modalService: NzModalService = inject(NzModalService);
  private alertService: AlertService = inject(AlertService);

  @Input() refreshRequested?: () => void;

  constructor(private router: Router) { }

  getIconType(cosigner: NIASBizBllModelsEntityInfo): string {
    if (cosigner) {
      return cosigner.HasSigned ? 'check' : 'close';
    }
    return '';
  }

  ngOnInit() {
    this.authorisationsApiClientService.authorizationsApiGetDocumentInfo(this.row.DocumentId).subscribe((x) => {
      this.fetchedDocument = x;
    });
  }

  callApproveBackend(documentId: any) {
    this.authorisationsApiClientService.authorizationsApiConfirmRepresentation(documentId).subscribe((response) => {
       if (this.refreshRequested) {
       this.refreshRequested();
     }
    });
    
    
  }

  approveDocument(documentId: any) {
    this.modalService.confirm({
      nzTitle: 'Jeste li sigurni da želite potvrditi dokument?',
      nzOkText: 'Da',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => {
        this.callApproveBackend(documentId)
        this.alertService.open('success', 'Dokument je uspješno potvrđen.');

      },
      nzCancelText: 'Ne',
      nzOnCancel: () => console.log('Cancel')
    })
  }

  viewDocument() {
    this.router.navigate(['/scanned-document-supervisor', this.fetchedDocument.AuthDocumentId]);
  }

  openSudRegPopup(legalOib: string) {
    var uri = 'https://sudreg.pravosudje.hr/registar/f?p=150:28:0::NO:28:P28_OIB:' + legalOib;

    this.helperApiService.helperApiReferentBrowse(uri).subscribe(() => {
      window.open(uri, '', 'width=1020,height=800,scrollbars=1');
    });
  }

  rejectDocument(documentId: any) {
    this.router.navigate(['/reject-authorization', this.fetchedDocument.AuthDocumentId]);
  }

  viewDocumentAttachments(legalEntityId: any) {
    this.router.navigate(['/attachment-list', this.fetchedDocument.ForLegal?.EntityGuid]);
  }
}
